import { Outlet } from 'react-router-dom'


export const Layout = () => {
    return (
        <div className='bg-white'>
            {/* <Header /> */}
            <main >
                <Outlet />
            </main>
            {/* <Footer /> */}
        </div>
    )
}
